module.exports = __webpack_public_path__ + "img/empyState.5e58b1b9.svg";